import {track} from '@amplitude/analytics-browser'
import logger from '@helpers/logger'

import { Properties } from './types'


const sendEventToAnalytics = (eventType: string, properties?: Properties) => {
  track(eventType, {...properties})
}

export default async function sendEvent(eventType: string, eventProperties: Properties = {}) {
  try {
    const obj: Properties = JSON.parse(JSON.stringify(eventProperties))
    sendEventToAnalytics(eventType, obj)
  } catch (error) {
    logger.error('Failed Amplitude sendEvent', {error, eventType})
  }
}
